import { createAtlasClient } from "@atlas-int/data";

const {
  REACT_APP_API_STAGING_REWRITE_BASE_URL,
  REACT_APP_API_REWRITE_BASE_URL,
} = import.meta.env;

const envBase = import.meta.env.DEV
  ? (REACT_APP_API_STAGING_REWRITE_BASE_URL ?? "")
  : (REACT_APP_API_REWRITE_BASE_URL ?? "");

// In production the FE is colocated with the BE, so default to a relative
// /api path that hits the same origin. In dev the FE runs independently and
// must point at an absolute backend URL via the env var.
const apiBase = envBase ? envBase.replace(/\/$/, "") : "/api";

/**
 * Apollo Client singleton.
 * Exported for use in both React components (via ApolloProvider) and
 * React Router loaders (for prefetching into cache).
 */
export const apolloClient = createAtlasClient({
  graphqlUrl: `${apiBase}/graphql`,
  cachePolicies: {
    countryYear: { keyArgs: ["productClass"] },
    productYear: { keyArgs: ["productLevel", "productClass"] },
  },
});

export default apolloClient;
